import styled from '@emotion/styled'
import { Grid } from "@mui/material";
export const EditProfilePageStyled = {
  Container: styled(Grid)<any>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 100%;
    flex-wrap: wrap;
  `,
  TitlePage: styled.p<any>`
    margin-bottom: 30px;
    font-family: EncodeSans-Medium;
    font-size: 20px;
    text-align: center;
  `,
  ContainerForm: styled(Grid)<any>`
    padding: 24px;
  `,
};
